import { IQuotationApprovalSteps } from "interfaces/quotation-detail.interface";
import React from "react";
import { Card, CardBody, CardTitle, Badge } from "reactstrap";

interface ApprovalStepsProps {
	data: IQuotationApprovalSteps[];
}

export default function ApprovalSteps({ data }: ApprovalStepsProps) {
	return (
		<Card className="mt-3">
			<CardBody>
				<CardTitle
					tag="h5"
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between"
					}}
				>
					<span>Tahapan Approval</span>
					<div className="break-line" />
				</CardTitle>
				{data && data.length > 0 ? (
					data.map((item, index) => (
						<div key={item.id || index} className="mb-2">
							<div className="d-flex justify-content-between align-items-center">
								<span className="text-xs text-black">
									{item.step}
								</span>
								<div className="d-flex gap-2">
									{index === data.length - 1 && (
										<Badge color="info" pill>
											Saat ini
										</Badge>
									)}
									{item.metadata?.additionalStatus && (
										<Badge
											color={
												item.metadata?.additionalStatus
													?.isActive
													? "success"
													: "secondary"
											}
											pill
										>
											{
												item.metadata?.additionalStatus
													?.name
											}
										</Badge>
									)}
								</div>
							</div>
							{index < data.length - 1 && <hr className="my-2" />}
						</div>
					))
				) : (
					<div className="text-muted text-xs">
						No approval steps available
					</div>
				)}
			</CardBody>
		</Card>
	);
}
